// extracted by mini-css-extract-plugin
export var settingsList = "_2u-0";
export var settingsRow = "_2u-1";
export var warningDot = "_2u-2";